import React from 'react';
import type { TextT } from '@mentimeter/ragnar-ui/text';
import { Text } from '@mentimeter/ragnar-ui/text';

export const Subheading = (props: TextT) => (
  <Text as="p" fontSize={['125', null, null, '150']} {...props} />
);
